import { actionTypes } from "../actions/clippings";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGNS_CLIPPINGS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;